import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { selectUser } from '../../../../../store/app.selectors';
import { setLoadingChannel } from '../../../../../modules/shared/store/ui.actions';
import { IUserProfile } from '../../../../user/interfaces/IUserProfile';
import { ChannelServiceType, IChannelByParams } from '../../../interfaces/IChannel';
import { PermissionsService } from '../../../services/permissions.service';
import { getChannel, toggleSidebar } from '../../../store/chat.actions';
import { AppStateWithChat } from '../../../store/chat.reducer';

@Component({
  selector: 'ngx-new-phone-chat',
  templateUrl: './new-phone-chat.component.html',
  styleUrls: ['./new-phone-chat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewPhoneChatComponent {
  private fb = inject(FormBuilder);
  private store = inject(Store<AppStateWithChat>);
  private dialogRef = inject(MatDialogRef<NewPhoneChatComponent>);
  permissionsService = inject(PermissionsService);

  user = toSignal(this.store.select(selectUser), { initialValue: null as IUserProfile | null });
  isLoading = signal(false);
  phoneControl: FormControl = this.fb.control(null, [Validators.required]);
  newChatForm: FormGroup = this.fb.group({
    firstName: [null, [Validators.required]],
    lastName: [null, [Validators.required]],
    phone: this.phoneControl,
    routing: ['SMS', [Validators.required]],
  });

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.isLoading.set(true);
    this.store.dispatch(setLoadingChannel({ value: true }));
    this.store.dispatch(toggleSidebar({ active: false }));
    const data: IChannelByParams = {
      phoneNumber: this.formatNumber(this.newChatForm.value['phone'] as string),
      routing: this.newChatForm.value['routing'] as ChannelServiceType,
      consent: { optIn: true, optOut: false },
      displayName: `${this.newChatForm.value['firstName'] as string} ${this.newChatForm.value['lastName'] as string}`,
      channelWithoutOrder: true,
      ownerId: this.user()?.subjectMessageableEntity?.businessReference?.entityUID,
    };
    this.store.dispatch(
      getChannel({
        channelByParams: data,
        tryCreateChannel: true,
        channelUID: null,
        autoSelect: true,
        updateChannel: true,
      })
    );
    this.dialogRef.close();
  }

  formatNumber(text: string): string {
    return text.replace(/[\s-]/g, '');
  }
}
